module.exports = __webpack_public_path__ + "static/media/invest-bharatpe-intro-2.24c1761e.png";